import React from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

import BackArrow from '../../public/assets/icons/see-all.svg';
import BOIBackArrow from '../../public/assets/nevo-boi/chevron-right.svg';
import { useIsBoiWebsite } from "../Context/WebsiteType";

interface IThanks {
  make: string;
  model: string;
  dealership?: string;
  goBack: () => void;
}

const Thanks = ({ make, model, dealership, goBack } : IThanks) => {

  const isBoiWebsite = useIsBoiWebsite();
  const arrowSrc = isBoiWebsite
    ? BOIBackArrow
    : BackArrow;

  return (
    <div className={styles.thanks}>
      <h1 className={styles.thanksHeader}>Thanks!</h1>

      <p className={styles.thanksText}>
        A member of the team { dealership && `from ${dealership}` } will be in touch with you soon.
      </p>

      <div className={styles.thanksBackHolder} onClick={goBack}>
        <Image className={isBoiWebsite ? styles.backImage : ""} src={arrowSrc} alt="back arrow" width={24} height={24} />
        <p className={isBoiWebsite ? styles.boi : styles.nevo}>Back to the {make} {model}</p>
      </div>
    </div>
  )
}

export default Thanks;